<template>
  <v-dialog v-model="showModalComputed" width="800px">
    <v-card>
      <v-card-title class="primary white--text">Fuentes de Datos</v-card-title>
      <v-container>
        <v-tabs v-model="sourcesActiveTab">
          <v-tab> <v-icon small left>mdi-rss</v-icon>Noticias </v-tab>
          <v-tab> <v-icon small left>mdi-twitter</v-icon>Twitter </v-tab>
          <v-tab> <v-icon small left>mdi-file-multiple</v-icon>Archivos </v-tab>
          <v-tab> <v-icon small left>mdi-map-marker</v-icon>Mapa </v-tab>
          <v-tab-item>
            <v-card flat>
              <v-form ref="formSourceNews">
                <v-row class="mx-2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="news.keywords"
                      placeholder="Keywords"
                      :rules="keywordsRules"
                      autofocus
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mx-2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="news.numDocuments"
                      placeholder="Número de artículos"
                      :rules="numNewsRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
              <v-row class="mx-2">
                <v-col cols="12">
                  <v-menu
                    v-model="news.datesMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    min-width="240px"
                    transition="scale-transition"
                    offset-y
                    disabled
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="newsDateRangeText"
                        label="Rango de Fechas"
                        prepend-icon="event"
                        dense
                        readonly
                        outlined
                        hide-details
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="news.dates" no-title range>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="
                          news.datesMenu = false;
                          news.dates = [];
                        "
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="news.datesMenu = false"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-form ref="formSourceTwitter">
                <v-row class="mx-2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="twitter.keywords"
                      placeholder="Keywords"
                      :rules="keywordsRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mx-2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="twitter.numDocuments"
                      placeholder="Número de twitts"
                      :rules="numDocsRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-form ref="formSourceFile">
                  <v-row class="mx-2">
                    <v-col cols="12">
                      <v-file-input
                        v-model="files"
                        accept=".doc, .docx, .pdf, .txt, .xls, .xlsx"
                        label="Subir archivos"
                        :rules="fileRules"
                        :loading="fileLoading"
                        small-chips
                        show-size
                        multiple
                      ></v-file-input>
                      <span class="body-2"
                        >* Soporta archivos de Word, PDF y TXT de máximo
                        32MB.</span
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-row no-gutters>
                  <v-col cols="12" md="6">
                    <gmap-map
                      ref="mapRef"
                      :center="this.map.location"
                      :zoom="7"
                      @click="mapClick($event)"
                      map-type-id="terrain"
                      v-bind:style="{
                        height: mapHeigth,
                        border: '1px solid gray',
                      }"
                    ></gmap-map>
                  </v-col>
                  <v-col>
                    <v-form ref="formSourceMap">
                      <v-row class="mx-md-4">
                        <v-col cols="12">
                          <gmap-autocomplete
                            class="introInput"
                            :options="{ fields: ['geometry'] }"
                            @place_changed="setPlace"
                          >
                            <template v-slot:input="slotProps">
                              <v-text-field
                                placeholder="Busca un Lugar"
                                ref="input"
                                v-on:listeners="slotProps.listeners"
                                v-on:attrs="slotProps.attrs"
                                prepend-inner-icon="place"
                                autocomplete="off"
                                clearable
                              ></v-text-field>
                            </template>
                          </gmap-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row class="mx-md-4">
                        <v-col cols="12">
                          <v-text-field
                            v-model="map.numDocuments"
                            placeholder="Número de eventos"
                            :rules="numDocsRules"
                            autocomplete="off"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="mx-md-2">
                        <v-col cols="12">
                          <v-subheader class="pl-md-2 pl-0"
                            >Radio {{ mapSelectedRadious }} Km</v-subheader
                          >
                          <v-slider
                            v-model="map.radious"
                            :max="4"
                            step="1"
                            :tick-labels="map.ticksLabels"
                            ticks="always"
                            tick-size="3"
                          ></v-slider>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('hide-modal')">Cancel</v-btn>
        <v-btn text color="primary" @click="addSource">Adicionar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/*
  global google
*/
import { GmapsOptions } from "@/commons/chart-commons.js";
const defaultNews = {
  keywords: "",
  numDocuments: undefined,
  datesMenu: false,
  dates: [],
};

const defaultTwitter = {
  keywords: "",
  numDocuments: undefined,
};

const defaultMap = {
  location: GmapsOptions.defaultLocation,
  numDocuments: undefined,
  radious: 2,
  ticksLabels: [1, 3, 5, 10, 50],
  mapMarker: undefined,
  mapCircle: undefined,
};

export default {
  data() {
    return {
      sourcesActiveTab: 0,
      files: [],
      fileLoading: false,
      news: {
        ...defaultNews,
      },
      twitter: {
        ...defaultTwitter,
      },
      map: {
        ...defaultMap,
      },
      keywordsRules: [(v) => !!v || "Al menos un keyword es requerido"],
      numNewsRules: [
        (v) => {
          if (!isNaN(parseFloat(v)) && v >= 0 && v <= 100) return true;
          return "Debe ser un número entre 0 y 100";
        },
      ],
      numDocsRules: [
        (v) => {
          if (!isNaN(parseFloat(v)) && v >= 0 && v <= 10000) return true;
          return "Debe ser un número entre 0 y 10000";
        },
      ],
      fileRules: [(v) => !!v || "Al menos un archivo es requerido"],
    };
  },
  props: {
    copraUrl: { type: String, default: process.env.VUE_APP_COPRA_SERVER_URL },
    showModal: {
      type: Boolean,
      default: true,
    },
    datasetUid: {
      type: String,
      required: true,
    },
  },
  methods: {
    sortDateRange(dateRange) {
      if (dateRange.length == 2) {
        let date1 = new Date(dateRange[0]);
        let date2 = new Date(dateRange[1]);
        if (date1 < date2) {
          return dateRange;
        } else {
          return [dateRange[1], dateRange[0]];
        }
      }
    },
    addSource() {
      switch (this.sourcesActiveTab) {
        case 0: //News
          if (this.$refs.formSourceNews.validate()) {
            let source = {
              name: "news.google.com",
              keywords: this.news.keywords,
              numDocs: parseInt(this.news.numDocuments),
            };
            if (this.news.dates.length == 2) {
              let sortedDates = this.sortDateRange(this.news.dates);
              source["fromTime"] = sortedDates[0];
              source["toTime"] = sortedDates[1];
            }
            this.$emit("add-source", source);
            this.$refs.formSourceNews.reset();
            this.news = { ...defaultNews };
          }
          break;
        case 1: //Twitter
          if (this.$refs.formSourceTwitter.validate()) {
            let source = {
              name: "twitter-api",
              keywords: this.twitter.keywords,
              numDocs: parseInt(this.twitter.numDocuments),
            };
            this.$emit("add-source", source);
            this.$refs.formSourceTwitter.reset();
            this.twitter = { ...defaultTwitter };
          }
          break;
        case 2: //File
          if (this.$refs.formSourceFile.validate()) {
            this.submitFile();
          }
          break;
        case 3: //Map
          if (this.$refs.formSourceMap.validate()) {
            let source = {
              name: "map",
              numDocs: parseInt(this.map.numDocuments),
              location: JSON.stringify({
                lat: this.map.location.lat,
                lng: this.map.location.lng,
                radious: this.map.ticksLabels[this.map.radious],
              }),
            };
            this.$emit("add-source", source);
            this.$refs.formSourceMap.reset();
            this.map = { ...defaultMap };
          }
          break;
      }
    },
    async submitFile() {
      if (this.files) {
        this.fileLoading = true;

        for (let i = 0; i < this.files.length; i++) {
          let file = this.files[i];
          let formData = new FormData();
          formData.append("datasetUid", this.datasetUid);
          formData.append("file", file, file.name);
          try {
            let response = await fetch(
              `${this.copraUrl}/files/upload?jwt=${this.getToken}`,
              {
                method: "POST",
                body: formData,
              }
            );
            if (response.ok) {
              let data = await response.json();
              console.log(data);
              let source = {
                name: file.name,
                numDocs: 1,
                s3Path: data.file,
              };
              this.$emit("add-source", source);
            }
          } catch (error) {
            console.error(error);
          }
        }
        this.fileLoading = false;
        this.files = [];
      }
    },
    setPlace(place) {
      this.map.location = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
    },
    mapClick(event) {
      if (this.map.mapMarker) {
        this.map.mapMarker.setMap(undefined);
      }
      if (this.map.mapCircle) {
        this.map.mapCircle.setMap(undefined);
      }

      const position = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
      this.map.location = {
        lat: position.lat,
        lng: position.lng,
      };
      this.map.mapMarker = new google.maps.Marker({
        map: this.$refs.mapRef.$mapObject,
        position: position,
      });
      this.map.mapCircle = new google.maps.Circle({
        map: this.$refs.mapRef.$mapObject,
        radius: this.getRadious(),
        center: position,
        fillColor: "#777",
        fillOpacity: 0.5,
        strokeColor: "#AA0000",
        strokeOpacity: 0.8,
        strokeWeight: 2,
      });
      this.$refs.mapRef.panTo(position);
    },
    getRadious() {
      return 1.60934 * this.map.ticksLabels[this.map.radious] * 1000;
    },
  },
  computed: {
    getToken() {
      return this.$store.getters.getToken;
    },
    newsDateRangeText() {
      if (this.news.dates.length == 2) {
        return this.sortDateRange(this.news.dates).join(" ~ ");
      }
      return "";
    },
    mapHeigth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
          return "240px";
        case "md":
        case "lg":
        case "xl":
          return "320px";
      }
      return "320px";
    },
    mapSelectedRadious() {
      return this.map.ticksLabels[this.map.radious];
    },
    showModalComputed: {
      get() {
        return this.showModal;
      },
      set(value) {
        if (!value) {
          this.$emit("hideModal");
        }
      },
    },
  },
};
</script>

<style>
</style>